import { Component, Input, ViewEncapsulation } from "@angular/core";

import type { DriveViewerPresentationFacade } from './drive-viewer.presentation-facade';

type DriveTreeViewPort = Pick<DriveViewerPresentationFacade,
  'childFolders' | 'childTreeItems' | 'closeContextMenu' | 'currentFolderId' | 'displayName'
  | 'dragHoverFolderId' | 'dropListId' | 'getItemIcon' | 'getItemIconClass'
  | 'hasChildFolders' | 'hasChildren' | 'isExpanded' | 'isFolderDropCandidate' | 'isVirtualFolderId'
  | 'navigateTo' | 'onDropOnFolder' | 'onFolderDragEntered' | 'onFolderDragExited'
  | 'onNativeDropOnFolder' | 'onNativeFolderDragLeave' | 'onNativeFolderDragOver'
  | 'onRootContextMenu' | 'onTreeContextMenu' | 'onTreeItemClick' | 'onTreeItemDoubleClick'
  | 'rootFolder' | 'selectedIds' | 'sourceDropListIds' | 'toggleExpand' | 'trackById'
  | 'translate'>;

@Component({
  selector: "app-drive-viewer-tree",
  templateUrl: "./drive-viewer-tree.component.html",
  styleUrls: [
    "./drive-viewer.component.shell-and-tree.scss",
    "./drive-viewer.component.content-and-results.scss",
    "./drive-viewer.component.preview-and-dialogs.scss",
    "./drive-viewer.component.overlays-and-states.scss",
    "./drive-viewer.component.responsive.scss",
    "./drive-viewer-mobile.component.scss"
  ],
  encapsulation: ViewEncapsulation.None,
  host: { style: "display: contents" },
  standalone: false
})
export class DriveViewerTreeComponent {
  @Input({ required: true }) view!: DriveTreeViewPort;
}
